module.exports = __webpack_public_path__ + "img/分享店铺.d5c5cff5.svg";